import { basicMsg, msg as swalMsg } from './swal_msg';
import { types } from '../types/types';

import { generateURL } from '../helpers/admin/productHelper';
import { axiosProtectedReq, protectedAxiosReq, protectedReq } from '../helpers/requestHelper';

import { CATEGORY_INIT } from '../constants/admin/category_const';

// cargar categorías y marcas de producto de BD
export const categoriesLoad = () => {
    return async (dispatch) => {
        try {
            const resp = await protectedReq('product/category/get');
            const body = await resp.json();
            if (body.status)
                dispatch(categoriesLoaded(body.resp));
            // else
            // basicMsg('No se pudieron cargas las categorías/marcas de producto');
        } catch (err) {
            // msg('warning', 'Productos',
            // 'Problema para recuperar categorías/marca de producto');
        };
    };
};

// categorías y marcas cargadas
const categoriesLoaded = (payload) => ({
    type: types.categoriesLoaded, payload
});

// guardar categoría/subcategorías de producto
export const saveCategory = (model, setMainCategory, setLoading, { flag, setOpen }) => {
    return async (dispatch) => {
        try {
            const { category, subcategories, imgFile } = model;
            const data = new FormData();
            data.append('category', category.toUpperCase());
            data.append('url', generateURL(category));
            data.append('subcategories_json', JSON.stringify(subcategories.map(e => e.toUpperCase())));
            data.append('file', imgFile);
            const resp = await axiosProtectedReq('product/category/save', data, 'POST');
            if (resp.status) {
                setMainCategory(e => ({ ...e, ...CATEGORY_INIT }));
                dispatch(categoryAdded(resp.resp));
                swalMsg('success', 'Categoría',
                'La categoría se ha creado de manera exitosa')
                if (flag)
                    setOpen(false);
            } else {
                if (resp.msg === 'exists') {
                    swalMsg('warning', 'Categoría', 'La categoría ya existe');
                } else if (resp.msg === 'server-err') {
                    swalMsg('warning', 'Categoría',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                } else
                    swalMsg('warning', 'Categoría',
                    'Inténtelo de nuevo, por favor');
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            swalMsg('warning', 'Categoría',
            'No se pudo registrar la categoría');
        };
    };
};

// categoría de producto añadida
const categoryAdded = (payload) => ({
    type: types.categoryAdded, payload
});

// guardar subcategoría
export const saveSubcategory = (model, setFields) => {
    return async (dispatch) => {
        try {
            const { category, ...obj } = model;
            const resp = await protectedReq('product/category/save-subcategory', obj, 'PUT');
            const body = await resp.json();
            if (body.status) {
                dispatch(subcategoryAdded(obj));
                setFields((e) => ({ ...e, subcategoryField: '' }));
            } else {
                if (body.msg === 'miss')
                    basicMsg(`Falta información de categoría ${category}`);
                else if (body.msg === 'not-saved')
                    basicMsg('No se pudo agregar la subcategoría');
                else if (body.msg === 'server-err')
                    swalMsg('warning', 'Subcategoría',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else
                    swalMsg('warning', 'Subcategoría',
                    'Inténtelo de nuevo, por favor');
            }
        } catch (err) {
            swalMsg('warning', 'Subcategoría',
            'No se pudo registrar la subcategoría');
        };
    };
};

// subcategoría añadida
const subcategoryAdded = (payload) => ({
    type: types.subcategoryAdded, payload
});

// eliminar subcategoría
export const deleteSubcategory = (model) => {
    return async (dispatch) => {
        try {
            const { category, ...obj } = model;
            const resp = await protectedReq('product/category/delete-subcategory', obj, 'DELETE');
            const body = await resp.json();
            if (body.status)
                dispatch(subcategoryDeleted(obj));
            else {
                if (body.msg === 'miss')
                    basicMsg(`Falta información de categoría ${category}`);
                else if (body.msg === 'not-deleted')
                    basicMsg('No se pudo eliminar la subcategoría');
                else if (body.msg === 'server-err')
                    swalMsg('warning', 'Subcategoría',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else
                    swalMsg('warning', 'Subcategoría',
                    'Inténtelo de nuevo, por favor');
            }
        } catch (err) {
            swalMsg('warning', 'Subcategoría',
            'No se pudo eliminar la subcategoría');
        };
    };
};

// subcategoría eliminada
const subcategoryDeleted = (payload) => ({
    type: types.subcategoryDeleted, payload
});

// eliminar categorías de producto
export const deleteCategories = (categories, setOpenAlert) => {
    return async (dispatch) => {
        try {
            const resp = await protectedReq('product/category/delete-many', { categories }, 'DELETE');
            const body = await resp.json();
            if (body.status) {
                dispatch(categoriesDeleted(body.resp));
                setOpenAlert(true);
            } else {
                if (resp.msg === 'not-deleted')
                    swalMsg('warning', 'Categoría',
                    'Una o más categorías pudieron no ser eliminadas');
                else if (resp.msg === 'server-err')
                    swalMsg('warning', 'Categoría',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else
                    swalMsg('warning', 'Categoría',
                    'Inténtelo de nuevo, por favor');
            }
        } catch (err) {
            swalMsg('warning', 'Categoría',
            'No se pudo eliminar la categoría(s)');
        };
    };
};

// categorías eliminadas
const categoriesDeleted = (payload) => ({
    type: types.categoriesDeleted, payload
});

// eliminar categoría/subcategorías de producto
export const deleteCategory = (category, categories) => {
    return async (dispatch) => {
        try {
            const { _id } = category;
            const resp = await protectedReq('product/category/delete', category, 'DELETE');
            const body = await resp.json();
            if (body.status)
                dispatch(categoryDeleted(categories.filter(e => e._id !== _id)));
            else {
                if (body.msg === 'miss')
                    basicMsg('Falta información de categoría');
                else if (body.msg === 'not-deleted')
                    basicMsg('Categoría no eliminada');
                else if (body.msg === 'server-err')
                    swalMsg('error', 'Categoría',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else
                    swalMsg('warning', 'Categoría',
                    'Inténtelo de nuevo, por favor');
            }
        } catch (err) {
            swalMsg('error', 'Categoría',
            'No se pudo registrar la categoría');
        };
    };
};

// categoría eliminada
const categoryDeleted = (payload) => ({
    type: types.categoryDeleted, payload
});

// eliminar categoría/subcategorías de producto
export const updateAllCategories = (allCategories, setLoading) => {
    return async (dispatch) => {
        try {
            const category = allCategories.map(
                ({ _id, category, subcategories }) => ({ _id, category, subcategories })
            );
            const resp = await protectedReq('product/category/update-all', { category }, 'PUT');
            const body = await resp.json();
            if (body.status)
                dispatch(categoriesUpdated(allCategories));
            else {
                if (body.msg === 'miss')
                    basicMsg('No se enviaron las categorías');
                else if (body.msg === 'server-err')
                    swalMsg('error', 'Categorías',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else
                    swalMsg('warning', 'Categorías',
                    'Inténtelo de nuevo, por favor');
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            swalMsg('error', 'Categorías',
            'No se pudieron actualizar las categorías');
        };
    };
};

// categorías actualizadas
const categoriesUpdated = (payload) => ({
    type: types.categoriesUpdated, payload
});
// image de categoría actualizada
const categoryImgUpdated = (payload) => ({
    type: types.categoryImgUpdated, payload
});

// actualizar imagen de categoría
export const updateImg = ({ _id, imgId, imgFile }) => {
    return async (dispatch) => {
        try {
            const data = new FormData();
            data.append('_id', _id);
            data.append('fileId', imgId);
            data.append('file', imgFile);

            const body = await protectedAxiosReq(
                'product/category/update-img', data, 'POST', dispatch
            );
            if (body) {
                const { status, msg, resp } = body;
                if (status) {
                    const { imgId } = resp;
                    dispatch(categoryImgUpdated({ _id, imgId }));
                } else {
                    if (msg === 'category-not-updated')
                        basicMsg('Categoría no actualizada');
                    else if (msg === 'img-not-uploaded')
                        basicMsg('Imagen de categoría no subida');
                    else if (msg === 'category-not-found')
                        basicMsg('No se encontró la categoría a actualizar');
                    else if (msg === 'no-file')
                        basicMsg('No se envió imagen a subir');
                    else if (msg === 'server-err')
                        msg('warning', 'Categoría',
                        'Ocurrió un incidente al actualizar imagen');
                    else
                        msg('warning', 'Categoría',
                        'Inténtelo de nuevo, por favor');
                }
            }
        } catch (err) {
            swalMsg('warning', 'Categoría',
            'No se pudo actualizar imagen de categoría');
        };
    };
};